import { createCategoryLandingDefaultFormFields } from '../common/formFields'
import { buildDefaultSurveyCustomFields } from '../common/defaultSurveyFields'
import { getCategoryLandingHeroImage } from '../common/heroImages'
import { leadGenFullbleedTemplateStyleForCategory } from '../common/leadGenFullbleedKeys'

export function getPersonalIntroPreset(presetKey = 'default') {
  const copyByPreset = {
    default: {
      heroTitle: '고객님의 든든한 금융 동반자입니다',
      heroSubtitle: '신뢰와 전문성으로 고객님의 미래를 함께 설계하겠습니다.',
      formTitle: '1:1 무료 상담 신청',
    },
    'basic-template-4': {
      heroTitle: '숫자로 증명하고 상담으로 신뢰를 만드는 설계사입니다',
      heroSubtitle: '상담 경험·응답·고객 만족 지표를 바탕으로, 꾸준히 신뢰를 쌓아온 상담 방식을 소개합니다.',
      formTitle: '1:1 전략 상담 신청',
    },
    'basic-template-5': {
      heroTitle: '한 분 한 분의 상황에 맞는 전략을 설계하는 금융 파트너입니다',
      heroSubtitle: '처음 상담부터 가입 이후 관리까지 책임 있게 함께하겠습니다.',
      formTitle: '프리미엄 상담 요청',
    },
  }
  const copy = copyByPreset[presetKey] || copyByPreset.default
  const baseSections = [
    {
      type: 'text',
      title: '저는 이런 설계사입니다',
      content: '고객의 상황을 먼저 듣고 필요한 보장만 제안합니다.\n\n고객 중심의 맞춤형 상담, 투명한 안내, 가입 이후의 관리까지 신뢰를 최우선으로 생각합니다.',
    },
    {
      type: 'testimonial',
      title: '고객님들의 소중한 이야기',
      items: [
        { name: '김○○님', content: '상황에 맞는 보험을 정리해주셔서 부담이 줄었습니다.' },
        { name: '이○○님', content: '가입 이후에도 꾸준히 챙겨주셔서 믿음이 갔습니다.' },
      ],
    },
    {
      type: 'text',
      title: '제가 특히 강점을 가진 분야',
      content: '은퇴 설계, 가족 보장 점검, 기존 보험 분석과 리모델링 등 고객 상황에 맞는 상담을 제공합니다.',
    },
  ]

  const baseSurveyFields = buildDefaultSurveyCustomFields('PERSONAL_INTRO')

  const introStats = []

  if (presetKey === 'lead-gen-fullbleed') {
    return {
      key: 'personal-intro-lead-gen-fullbleed',
      category: 'PERSONAL_INTRO',
      name: '본인소개홈페이지 기본 템플릿 6 - 풀블리드 전환형',
      heroTitle: copy.heroTitle,
      heroSubtitle: copy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage('PERSONAL_INTRO'),
      formTitle: copy.formTitle,
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🤝', title: '신뢰 중심 상담', description: '필요한 보장만 투명하게 짚어드립니다.' },
            { icon: '📊', title: '상담 기록 기반 안내', description: '상담 이력과 관리 방식을 바탕으로 안내합니다.' },
            { icon: '💬', title: '상담 문의', description: '폼으로 남겨 주시면 순차적으로 연락드립니다.' },
          ],
        },
        ...baseSections.slice(0, 2),
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: baseSurveyFields,
      customConfig: {
        templateStyle: leadGenFullbleedTemplateStyleForCategory('PERSONAL_INTRO'),
        heroBandBackgroundColor: '#ECEAFF',
        detailStripBackgroundColor: '#F7F7F7',
        heroDetailImageFileId: '',
        formBorderColor: '#1f2937',
        formBorderWidth: 2,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
        introStats,
      },
    }
  }

  if (presetKey === 'basic-template-4') {
    return {
      key: 'personal-intro-basic-template-4',
      category: 'PERSONAL_INTRO',
      name: '본인소개홈페이지 기본 템플릿 4 - CTA 강조형',
      heroTitle: copy.heroTitle,
      heroSubtitle: copy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage('PERSONAL_INTRO'),
      formTitle: copy.formTitle,
      contentSections: [
        ...baseSections,
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: baseSurveyFields,
      customConfig: {
        templateStyle: 'basic-template-4',
        heroBackgroundColor: '#f3f4f6',
        heroTextColor: '#111827',
        heroSubtitleColor: '#4b5563',
        formBorderColor: '#1f2937',
        formBorderWidth: 2,
        ctaBandBackgroundColor: '#e5e7eb',
        introStats,
      },
    }
  }

  if (presetKey === 'basic-template-5') {
    return {
      key: 'personal-intro-basic-template-5',
      category: 'PERSONAL_INTRO',
      name: '본인소개홈페이지 기본 템플릿 5 - 프리미엄 상담형',
      heroTitle: copy.heroTitle,
      heroSubtitle: copy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage('PERSONAL_INTRO'),
      formTitle: copy.formTitle,
      contentSections: baseSections,
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: baseSurveyFields,
      customConfig: {
        templateStyle: 'basic-template-5',
        heroBackgroundColor: '#111827',
        heroTextColor: '#ffffff',
        heroSubtitleColor: '#d1d5db',
        formBorderColor: '#111827',
        formBorderWidth: 2,
        bodyBackgroundColor: '#f8fafc',
        introStats,
      },
    }
  }

  return {
    key: 'personal-intro-default',
    category: 'PERSONAL_INTRO',
    name: '본인소개홈페이지 기본 템플릿 1 - 일반형',
    heroTitle: copy.heroTitle,
    heroSubtitle: copy.heroSubtitle,
    heroImageFileId: getCategoryLandingHeroImage('PERSONAL_INTRO'),
    formTitle: copy.formTitle,
    contentSections: baseSections,
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: baseSurveyFields,
    customConfig: {
      templateStyle: 'default',
      heroBackgroundColor: '#f8fafc',
      heroTextColor: '#0f172a',
      heroSubtitleColor: '#475569',
      introStats,
    },
  }
}
